import { FraseSecretaRequest } from "./fraseSecretaRequest.dto";

export class UsuarioPerfilDTO{
    token: string;
    refreshToken: string;
    servidor: string;
    matricula: number;
    funcao: string;
    lotacao: string;
    // perfil: string;
    status: string;
    FraseSecretaRequest: FraseSecretaRequest;
    
}

